"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
var _request = _interopRequireDefault(require("@/utils/request"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _goodForm = _interopRequireDefault(require("./goodForm.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default,
    GoodForm: _goodForm.default,
    Pagination: _index.default
  },
  data: function data() {
    return {
      // 顶部搜索框form数据
      formInline: {
        keyword: '',
        //搜索关键词
        active: '待审核'
      },
      dataList: {
        count: 0
      },
      dialogFormVisible: false,
      //是否显示新增产品form
      dialogFormVisibleRule: false,
      //是否显示新增产品form
      listLoading: true,
      is_day_nums: false,
      good_img: '',
      getimg: false,
      getrule: false,
      listQuery: {
        page: 1,
        page_size: 10
      },
      newRuledata: [],
      //账单预览的数据源
      currentRule: '',
      //保存当前点击的商品的扣款规则
      isDesktop: true,
      // 默认为桌面端
      showImageDialog: false // 控制图片弹窗显示
    };
  },
  created: function created() {
    // 如果currentPage为空，则默认为1
    this.listQuery.page = this.currentPage;
    this.getList();
  },
  mounted: function mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    getimgClick: function getimgClick(row) {
      var _this = this;
      this.getimg = true;
      // 获取图片进行展示
      (0, _request.default)({
        url: "/system/goods/goods_image_get/?goods_id=".concat(row.id),
        method: 'get'
      }).then(function (res) {
        if (res.code == 200) {
          // 保存为base64格式
          _this.good_img = "data:image/png;base64,".concat(res.data);
          _this.getimg = true;
          _this.showImageDialog = true; // 显示弹窗而不是消息提示
        }
      });
    },
    closeImageDialog: function closeImageDialog() {
      this.showImageDialog = false;
      this.good_img = '';
    },
    checkDevice: function checkDevice() {
      // 可以根据屏幕宽度判断是桌面还是移动端
      this.isDesktop = window.innerWidth >= 768;
    },
    // 新增的状态类型获取方法
    getStatusType: function getStatusType(status) {
      switch (status) {
        case '上架':
          return 'success';
        case '下架':
          return 'warning';
        case '待审核':
          return 'primary';
        default:
          return 'danger';
      }
    },
    // 新增的状态文本获取方法
    getStatusText: function getStatusText(status) {
      var statusMap = {
        '上架': '上架',
        '下架': '下架',
        '待审核': '待审核',
        '拒绝': '拒绝'
      };
      return statusMap[status] || status;
    },
    closeRule: function closeRule() {
      this.dialogFormVisibleRule = false;
      this.newRuledata = [];
      this.currentRule = '';
    },
    getCostRule: function getCostRule(rule) {
      var _this2 = this;
      this.currentRule = rule;
      console.log(rule, '当前商品规则');
      // 将返回的字符串转换成数组，放到newRuledata中
      var arr = rule.split(',');

      // 获取当前日期，这块需要做的处理比较多，和当时生成预览账单得逻辑要反过来
      arr.map(function (item, index) {
        // 在当前日期基础上加index天，输出格式 年月日  2025年3月28日这种
        var nowdate = new Date();
        var arrdate = new Date(nowdate);
        arrdate.setDate(nowdate.getDate() + index);
        if (item.includes('|')) {
          var miniarrr = [];
          var minimoney = 0;
          item.split('|').map(function (item1, index1) {
            minimoney += parseFloat(item1);

            // item1遍历生成一个数组 每个项包含date和money 然后放到item的splitmoney属性里
            miniarrr.push({
              // date: this.formatDatefn(arrdate),
              // date: arrdate,
              money: item1
            });
          });
          _this2.newRuledata.push({
            record: index,
            money: minimoney,
            // 金额直接用第一期的金额
            date: arrdate,
            splitmoney: miniarrr,
            splitnum: item.split('|').length
            // tempSplitnum: null, // 添加 tempSplitnum 属性
            // is_split: false,// 允许拆单
            // isSplitVisibel: true
          });
        } else {
          _this2.newRuledata.push({
            record: index,
            money: item,
            // 金额直接用第一期的金额
            date: arrdate,
            splitmoney: [],
            splitnum: 0
            // tempSplitnum: null, // 添加 tempSplitnum 属性
            // is_split: false,// 允许拆单
            // isSplitVisibel: false
          });
        }
      });

      // console.log(this.newRuledata)

      // // 将0的过滤掉
      this.newRuledata = this.newRuledata.filter(function (item) {
        return item.money != 0;
      });
      this.dialogFormVisibleRule = true;
      this.getrule = true;
    },
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/Goods/",
        method: 'get',
        params: Object.assign({
          shop: this.$user.data.shop,
          name: this.formInline.keyword,
          active: this.formInline.active
        }, this.listQuery)
      }).then(function (response) {
        if (response.data) {
          _this3.dataList = response.data;
        }
        _this3.listLoading = false;
        _this3.$emit('page-change', _this3.listQuery.page);
      });
    },
    // 根据id获取产品详情
    handleClick: function handleClick(item, type) {
      var _this4 = this;
      if (this.getrule == false) {
        this.$message.error('查看规则后再进行审核');
        return;
      }
      if (this.getimg == false) {
        this.$message.error('查看图片后再进行审核');
        return;
      }
      var type1 = '';
      if (type == '上架') {
        type1 = '通过';
      } else {
        type1 = '拒绝';
      }
      // 弹窗提示，如果用户确认则发请求
      this.$confirm("\u786E\u8BA4".concat(type1, "\u8BE5\u5546\u54C1\u5417"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _request.default)({
          url: "/system/goods/update_goods_status/",
          method: 'put',
          // params: { shop: this.$user.data.shop },// url参数
          data: {
            shop_id: _this4.$user.data.shop,
            goods_id: item.id,
            active: type
          }
        }).then(function (res) {
          if (res.code == 200) {
            _this4.$message.success('操作成功');
            _this4.getList();
          } else {
            _this4.$message.error('操作失败');
          }
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    // 顶部搜索框——根据商品名搜索
    handleFilter: function handleFilter(e) {
      this.listLoading = true;
      this.getList();
    },
    reload: function reload() {
      this.formInline.keyword = '';
      this.formInline.active = '待审核';
      this.getList();
    } // getimgClick(row) {
    //   this.getimg = true
    //   // 获取图片进行展示
    //   request({
    //     url: `/system/goods/goods_image_get/?goods_id=${row.id}`,
    //     method: 'get',
    //   }).then(res => {
    //     if (res.code == 200) {
    //       // 保存为base64格式
    //       this.good_img = `data:image/png;base64,${res.data}`
    //       this.getimg = true
    //       this.$message({
    //         dangerouslyUseHTMLString: true,
    //         message: '<img style="width:500px;height:500px" src="' + this.good_img + '"></img>',
    //         duration: 0,
    //         showClose: true
    //       });
    //     }
    //   })
    // }
  }
};